import { fromJS } from 'immutable';

export const getImagePreview = (state) => state.sku.get('imagePreview', fromJS({}));
